import { render, staticRenderFns } from "./CreateSettlementDriver.vue?vue&type=template&id=2c007016"
import script from "./CreateSettlementDriver.vue?vue&type=script&lang=js"
export * from "./CreateSettlementDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports